import { z } from "zod";
const ExpireOwnerLinkRequestsInputSchema = z
    .object({ limit: z.number().int().min(1).max(500).default(100) })
    .strict();
/**
 * Idempotently flips PENDING Owner Link requests past their `expiresAt`
 * to `EXPIRED` (`docs/products/stable.md` "Link An Owner": "Declined,
 * cancelled, or expired links never grant rights"), mirroring
 * `expireMarketplaceListings`. Not yet wired to a scheduled worker — see
 * the completion report; this matches the same not-yet-scheduled state
 * Phase 6/7 shipped `runVaccinationAlertScan`/`runAccountingAutoInvoiceScan`
 * in. `respondOwnerLinkRequest` independently re-checks `expiresAt` on every
 * accept/decline, so correctness never depends on this worker actually
 * running on a schedule.
 */
export async function expireOwnerLinkRequests(input, dependencies) {
    const parsed = ExpireOwnerLinkRequestsInputSchema.parse(input);
    const expired = await dependencies.repository.expireDueOwnerLinkRequests({
        now: dependencies.clock.now(),
        limit: parsed.limit,
    });
    return { expired };
}
